import { render, staticRenderFns } from "./OtherFilters.vue?vue&type=template&id=12f59954&scoped=true"
import script from "./OtherFilters.vue?vue&type=script&lang=js"
export * from "./OtherFilters.vue?vue&type=script&lang=js"
import style0 from "./OtherFilters.vue?vue&type=style&index=0&id=12f59954&prod&lang=scss&scoped=true"
import style1 from "./OtherFilters.vue?vue&type=style&index=1&id=12f59954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f59954",
  null
  
)

export default component.exports